<template>
  <b-row v-bind="$attrs" class="mb-3">
    <b-col>
      <label>{{ $t('labels.purchase_orders.purchase_order_item') }}</label>
      <div class="d-flex">
        <multiselect v-model="purchaseOrderItem" :max-height="200" placeholder=""
                     :tabindex="1"
                     @search-change="loadOrderItems" label="description_with_stock" track-by="id"
                     :loading="loading"
                     select-label="" deselect-label="" selected-label=""
                     :options="orderItems" :disabled="disabled"/>
      </div>
    </b-col>
  </b-row>
</template>
<script>
import { mapState } from 'vuex'
import Multiselect from 'vue-multiselect'

export default {
  name: 'PurchaseOrderItemSearchField',
  components: { Multiselect },
  model: {
    prop: 'value',
    event: 'change'
  },
  props: {
    disabled: {
      type: Boolean,
      default: () => false
    },
    value: {
      type: [Number, Object],
      default: () => ({})
    },
    contract: {
      type: Object,
      default: () => null
    },
    purchaseOrder: {
      type: Object,
      default: () => null
    }
  },
  data () {
    return {
      loading: false,
      purchaseOrderItem: null
    }
  },
  computed: {
    ...mapState('purchaseOrderItems', ['orderItems'])
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler () {
        if (typeof this.value === 'number') {
          this.purchaseOrderItem = this.orderItems.find(el => el.id === this.value)
        }
      }
    },
    purchaseOrderItem: {
      immediate: false,
      deep: true,
      handler () {
        console.log(this.purchaseOrderItem)
        if (this.purchaseOrderItem) {
          this.$emit('change', this.purchaseOrderItem)
          this.$emit('input', this.purchaseOrderItem)
        }
      }
    },
    contract: {
      immediate: true,
      deep: true,
      handler () {
        this.loadOrderItems()
      }
    },
    purchaseOrder: {
      immediate: true,
      deep: true,
      handler () {
        this.loadOrderItems()
      }
    }
  },
  methods: {
    async loadOrderItems (search = '') {
      if (this.purchaseOrder) {
        const params = {
          limit: 50,
          offset: 0,
          purchase_order_number: search,
          order_id: this.purchaseOrder.id,
          activity: true,
          contracts: this.contract?.id
        }
        this.loading = true
        await this.$store.dispatch('purchaseOrderItems/loadOrderItems', params)
        this.loading = false
      }
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/common/operation/PurchaseOrderItemSearchField.vue